import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component } from '@angular/core';

@Component({
  selector: 'cng-agent-booking-chat-inprocess',
  templateUrl: './agent-booking-chat-inprocess.component.html',
})
export class AgentBookingChatInprocessComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
